import { shrpaApi } from "./axios";

import { CustomerQuotesPayload } from "@contracts/pages";

export interface CustomerQuotesQueryParams {
  state?: string;
  logosCount?: number;
  quotesCount?: number;
}

export default {
  async getCustomerQuotes(params: CustomerQuotesQueryParams = {}): Promise<CustomerQuotesPayload> {
    const { data } = await shrpaApi.get<CustomerQuotesPayload>("/customer-quotes", { params });
    return data;
  },
};
